export default "__VITE_ASSET__5aNraEkc__"